<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="8">
                    <h1 class="headline font-weight-light mb-3">
                        VIEW STOCK
                    </h1>
                </v-col>
                <v-col cols="4" class="text-right">
                    <v-btn
                        small
                        rounded
                        color="yellow darken-2"
                        @click="get_replenish()"
                    >
                        <v-icon>mdi-poll-box</v-icon> replenish stock</v-btn
                    >
                </v-col>
            </v-row>

            <v-card>
                <v-row class="pa-5">
                    <v-col cols="12" sm="4" md="3">
                        <v-switch
                            v-model="chk_status"
                            :label="text_chk_status"
                            @change="func_chk_status()"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" sm="4" md="3" v-if="chk_status === false">
                        <v-autocomplete
                            item-text="branch_name"
                            item-value="branch_id"
                            menu-props="auto"
                            label="Select Branch"
                            hide-details
                            :items="data_branch.branchs"
                            v-model="form_branch.branch"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="4" md="3" v-if="chk_status === false">
                        <v-autocomplete
                            item-text="project_name"
                            item-value="project_id"
                            menu-props="auto"
                            label="Select Project"
                            hide-details
                            :items="data_branch.projects"
                            v-model="form_branch.projects"
                            @change="get_data()"
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="4" md="3" v-if="chk_status === true">
                        <v-autocomplete
                            item-text="project_name"
                            item-value="project_id"
                            menu-props="auto"
                            label="Select Project"
                            hide-details
                            :items="data_project"
                            v-model="form_project.projects"
                            @change="get_part()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="6"
                        sm="4"
                        md="3"
                        v-if="form_project.projects != ''"
                    >
                        <v-autocomplete
                            item-text="part_name"
                            item-value="part_id"
                            menu-props="auto"
                            label="Select Part"
                            hide-details
                            :items="data_part"
                            v-model="form_project.part"
                            @change="get_data()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="1" class="mt-4">
                        <v-btn
                            x-small
                            fab
                            class="mr-1"
                            @click="reset()"
                            v-if="
                                form_branch.branch != '' ||
                                    form_project.projects != ''
                            "
                        >
                            <v-icon>mdi-rotate-left</v-icon></v-btn
                        >
                    </v-col>
                </v-row>

                <v-simple-table
                    v-if="data_main.length > 0 && chk_status == false"
                    class="table-inv"
                >
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>

                                <th class="text-center">Part Name</th>
                                <th class="text-center">Part Description</th>
                                <th class="text-center">Level</th>
                                <th class="text-center">Qty Minimum</th>
                                <th class="text-center">Qty Branch</th>
                                <th class="text-center">Qty HQ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in data_main" :key="index">
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td>{{ row.part_name }}</td>
                                <td>{{ row.part_description }}</td>
                                <td class="text-center">{{ row.level }}</td>
                                <td class="text-center">
                                    {{ row.qty_minimum }}
                                </td>
                                <td class="text-center">
                                    {{ row.qty_branch }}
                                </td>
                                <td class="text-center">{{ row.qty_hq }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <v-simple-table
                    v-if="data_main.length > 0 && chk_status == true"
                    class="table-inv"
                >
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th class="text-center">Branch Name</th>
                                <th class="text-center">Level</th>
                                <th class="text-center">Qty Minimum</th>
                                <th class="text-center">Qty Branch</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in data_main" :key="index">
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td>{{ row.branch_name }}</td>
                                <td class="text-center">{{ row.level }}</td>
                                <td class="text-center">
                                    {{ row.qty_minimum }}
                                </td>
                                <td class="text-center">
                                    {{ row.qty_branch }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-container>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="12">
                                        <template>
                                            <v-data-table
                                                :headers="headers"
                                                :items="data_replenish"
                                                :items-per-page="5"
                                                class="elevation-1"
                                                :loading="isLoading"
                                                loading-text="Loading... Please wait"
                                            >
                                                <template
                                                    v-slot:[`item.Fullfill`]="{
                                                        item,
                                                    }"
                                                >
                                                    <span style="color:red">{{
                                                        item.qty_minimum -
                                                            item.qty_branch
                                                    }}</span>
                                                </template>
                                            </v-data-table>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    computed: {
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_branch()
        this.get_prijects()
    },
    created() {
        this.get_data = _.debounce(this.get_data, 300)
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            if (this.chk_status === false) {
                let sub_url =
                    "view-stock/branch/" +
                    this.form_branch.branch +
                    "/" +
                    this.form_branch.projects
                let { data } = await axios.get(url + sub_url)
                this.data_main = data
            } else if (this.chk_status === true) {
                let sub_url =
                    "view-stock/part/" +
                    this.form_project.projects +
                    "/" +
                    this.form_project.part
                let { data } = await axios.get(url + sub_url)
                this.data_main = data
            }
        },
        func_chk_status() {
            this.data_main = []
            if (this.chk_status === false) {
                this.text_chk_status = "Branch"
                this.form_project.projects = ""
                this.form_project.part = ""
            } else if (this.chk_status === true) {
                this.text_chk_status = "Part"
                this.form_branch.branch = ""
                this.form_branch.projects = ""
            }
        },
        reset() {
            this.data_main = []
            this.chk_status = false
            this.text_chk_status = "Branch"
            this.form_branch.branch = ""
            this.form_branch.projects = ""
            this.form_project.projects = ""
            this.form_project.part = ""
        },
        async get_branch() {
            let { data } = await axios.get(url + "project-has-stock", this.tk)
            this.data_branch = data
        },
        async get_prijects() {
            let { data } = await axios.get(url + "getprojects")
            this.data_project = data
        },
        async get_part() {
            let { data } = await axios.get(
                url + "get-all-part/" + this.form_project.projects
            )
            this.data_part = data
        },
        async get_replenish() {
            this.dialog = true
            await axios
                .get(url + "replenish-stock")
                .then((response) => {
                    this.data_replenish = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            text_chk_status: "Branch",
            chk_status: false,
            form_branch: {
                branch: "",
                projects: "",
            },
            form_project: {
                projects: "",
                part: "",
            },
            data_branch: [],
            data_project: [],
            data_replenish: [],
            data_part: [],
            data_main: [],
            dialog: false,
            tk: "",
            headers: [
                { text: "Branch Name", value: "branch_name" },
                { text: "Project Name", value: "project_name" },
                { text: "Part Name", value: "part_name" },
                { text: "Part Des.", value: "part_description" },
                { text: "Qty Minimum", value: "qty_minimum", align: "right" },
                { text: "Qty Branch", value: "qty_branch", align: "right" },
                {
                    text: "Fullfill",
                    value: "Fullfill",
                    align: "right",
                },
                { text: "Qty Hq", value: "qty_hq", align: "right" },
            ],
        }
    },
}
</script>
